import { ActionIcon, Tooltip } from "@mantine/core";
import { IconLayoutSidebar, IconLayoutSidebarLeftCollapse } from "@tabler/icons-react";

type SidebarCollapseButtonProps = {
  onClick: () => void;
  /** Icon color for dark sidebars (e.g. AppLayout). */
  color?: string;
};

type SidebarRailToggleButtonProps = SidebarCollapseButtonProps & {
  expanded: boolean;
};

/** Toggle between expanded sidebar and icon rail (top of desktop sidebar). */
export function SidebarRailToggleButton({ onClick, expanded, color }: SidebarRailToggleButtonProps) {
  const label = expanded ? "Collapse sidebar" : "Expand sidebar";
  const Icon = expanded ? IconLayoutSidebarLeftCollapse : IconLayoutSidebar;

  return (
    <Tooltip label={label} position="right" withArrow>
      <ActionIcon
        variant="subtle"
        size="lg"
        radius="md"
        color={color ?? "gray"}
        onClick={onClick}
        aria-label={label}
        style={{ flexShrink: 0 }}
      >
        <Icon size={20} stroke={1.75} />
      </ActionIcon>
    </Tooltip>
  );
}

/** @deprecated Use SidebarRailToggleButton with expanded={true} */
export function SidebarCollapseButton(props: SidebarCollapseButtonProps) {
  return <SidebarRailToggleButton {...props} expanded={true} />;
}
